export default {
    imageAIFormRules: {
        enterDescription: 'Bitte geben Sie die Beschreibung ein',
        invalidDescription: 'Bitte geben Sie eine gültige Beschreibung ein',
        enterNumberOfVariations: 'Bitte wählen Sie die Anzahl der Variationen',
        invalidNumberOfVariations: 'Sie können maximal 4 und minimal 1 Variante generieren',
        enterStyle: 'Bitte wähle mindestens einen Stil aus',
    },
};
